import '@mantine/core/styles.css';
import "./src/styles/global.css";

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    // Let anchor links scroll to their target as usual
    if (location.hash) {
        return true;
    }
    window.scrollTo(0, 0);
    return false;
};

export const onClientEntry = () => {
    if (typeof window !== 'undefined') {
        const originalFetch = window.fetch;
        window.fetch = (input, init = {}) => {
            if (typeof input === 'string' && input.includes('/page-data/')) {
                init.cache = 'no-store';
            }
            return originalFetch(input, init);
        };
    }
};